import { LineChart, Line, XAxis, YAxis, CartesianGrid, ResponsiveContainer } from 'recharts'

import CustomDot from './components/CustomDot'
import { calcRangePadding } from './helpers/calc-range-padding'
import useStyles from './style'
import CustomXAxisTick from './components/CustomXAxisTick'

const ChartLine = ({ data, decrease = false, isRank = false }) => {
  const classes = useStyles()

  return (
    <div className={classes.box}>
      <ResponsiveContainer>
        <LineChart data={data} margin={{ top: 8, right: 14, left: 14, bottom: 20 }}>
          {/* vertical lines */}
          <CartesianGrid vertical horizontal={false} stroke="#eee" />
          {/* X Axis */}
          <XAxis
            dataKey="week"
            domain={[-1, data.length - 2]}
            interval={0}
            tick={<CustomXAxisTick />}
            axisLine={false}
            tickLine={false}
          />
          {/* Y Axis hidden */}
          <YAxis reversed hide domain={([dataMin, dataMax]) => calcRangePadding(dataMin, dataMax)} />
          {/* Smooth line */}
          <Line
            type="monotone"
            dataKey="value"
            stroke={decrease ? '#1A0063' : '#1A0063'}
            strokeWidth={3}
            dot={<CustomDot isRank={isRank} />}
            activeDot={false}
            animationDuration={0}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  )
}

export default ChartLine
